import { Component, OnInit, ViewChild } from '@angular/core';
import { OrdenVentaComponent } from '../../../forms/orden-venta/orden-venta.component';
import { MatDialog } from '@angular/material';
import { TablaComponent } from '../../../forms/orden-venta/tabla/tabla.component';

@Component({
  selector: 'app-ordenes-venta',
  templateUrl: './ordenes-venta.component.html',
  styleUrls: ['./ordenes-venta.component.scss']
})
export class OrdenesVentaComponent implements OnInit {

  @ViewChild('tabla') tabla: TablaComponent;

  constructor(
    private _dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  crear = () => {
    this._dialog.open(OrdenVentaComponent, {
      disableClose: true,
      minWidth: '840px',
      data: {}
    }).afterClosed().subscribe((respuesta) => {
      this.tabla.actualizarTabla();
    });
  }

}
